// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"175":"79c547ecd3276b0d","205":"79c547ecd3276b0d","527":"79c547ecd3276b0d","888":"1b2f78ba2d665275"}[chunkId] + ".css";
};